import { jsxs as _jsxs } from "react/jsx-runtime";
import { createReactInlineContentSpec } from '@blocknote/react';
export const Mention = createReactInlineContentSpec({
    content: 'none',
    propSchema: {
        id: {
            default: '',
        },
        name: {
            default: '',
        },
        username: {
            default: '',
        },
    },
    type: 'mention',
}, {
    render: (props) => (_jsxs("a", { style: { fontWeight: 500 }, children: ["@", props.inlineContent.props.name] })),
});
//# sourceMappingURL=Mention.js.map